<div class="p-1 text-neutral-400 rounded-full hover:bg-neutral-50 hover:cursor-pointer" (click)="onCloseClick()">
  <svg class="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <g id="close">
      <path id="Vector" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
    </g>
  </svg>
</div>
